<template>
  <div>
    <v-row v-if="doesTemplateIncludeWeekOfYear()">
      <v-col cols="12" style="background: #606060">
        <v-pagination
          :dark="true"
          v-model="page"
          :circle="true"
          :length="numPages"
          :page="page"
          :total-visible="15"
        ></v-pagination>
      </v-col>
    </v-row>


    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          disable-pagination
          hide-default-footer
          class="elevation-1"
          flat
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr style="background: #606060" v-if="items.length > 0">
                <td>
                  <v-btn
                    rounded
                    outlined
                    color="primary"
                    @click="doFillColumns(items)"
                  >
                    fill columns
                  </v-btn>
                </td>
                <td>
                  <amount-input
                    :hide-details="true"
                    :label="''"
                    :init-amount="fillColumns.amount === null ? undefined : parseInt(fillColumns.amount, 10)"
                    @change="fillchange($event)"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="fillColumns.quantity"
                    outlined
                    dense
                    type="number"
                    :value="''"
                    hide-details
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="fillColumns.sku"
                    outlined
                    dense
                    type="text"
                    :value="''"
                    hide-details
                  />
                </td>
                <td>
                  <v-row>
                    <v-col
                      cols="6"
                      class="pr-0"
                    >
                      <v-text-field
                        v-model="fillColumns.weight"
                        outlined
                        dense
                        type="text"
                        :value="''"
                        hide-details
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      class="pl-0"
                    >
                      <v-overflow-btn
                        v-model="fillColumns.weightUnits"
                        :value="''"
                        flat
                        outlined
                        dense
                        :items="weightUnits"
                        item-value="id"
                        item-text="label"
                        label="Units"
                        append-icon=""
                        append-outer-icon=""
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </td>
                <td></td>
              </tr>

              <template v-for="(item, idx) in items">
                <tr v-if="item.isExcluded && item.inMatrix">

                  <td class="grey--text" width="20%">
                    {{ item.name }}
                  </td>
                  <td class="text-center">
                    This variant will be excluded.
                  </td>
                  <td/>
                  <td/>
                  <td/>
                  <td class="text-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          icon
                          v-on="on"
                          @click="updateModel(item, 'isExcluded', false)"
                        >
                          <v-icon small>
                            visibility
                          </v-icon>
                        </v-btn>
                      </template>

                      Show variant
                    </v-tooltip>
                  </td>
                </tr>
                <tr
                  v-if="!item.isExcluded && item.inMatrix"
                  :class="{
                    'new-row': !item.id && product.id
                  }"
                >
                  <td class="text-xs-left" width="20%">
                    {{ item.name }}
                  </td>
                  <td>
                    <amount-input
                      v-if="_isNumber(item.amount)"
                      :init-amount="item.amount"
                      @change="updateModel(item, 'amount', $event)"
                      :hide-details="true"
                      :label="''"
                    />
                  </td>
                  <td>
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      :value="item.quantity"
                      @change="updateModel(item, 'quantity', $event)"
                      hide-details
                    />
                  </td>
                  <td>
                    <v-text-field
                      outlined
                      dense
                      type="text"
                      :value="item.sku"
                      @change="updateModel(item, 'sku', $event)"
                      hide-details
                    />
                  </td>
                  <td>
                    <v-row>
                      <v-col
                        cols="6"
                        class="pr-0"
                      >
                        <v-text-field
                          outlined
                          dense
                          type="text"
                          :value="item.weight"
                          hide-details
                          @change="updateModel(item, 'weight', $event)"
                        />
                      </v-col>
                      <v-col
                        cols="6"
                        class="pl-0"
                      >
                        <v-overflow-btn
                          :value="item.weightUnits"
                          flat
                          outlined
                          dense
                          :items="weightUnits"
                          item-value="id"
                          item-text="label"
                          label="Units"
                          append-icon=""
                          append-outer-icon=""
                          hide-details
                          @change="updateModel(item, 'weightUnits', $event)"
                        />
                      </v-col>
                    </v-row>
                  </td>
                  <td class="text-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          icon
                          v-on="on"
                          color="white"
                          @click="updateModel(item, 'isExcluded', true)"
                        >
                          <v-icon small>
                            visibility_off
                          </v-icon>
                        </v-btn>
                      </template>

                      Hide variant
                    </v-tooltip>
                  </td>
                </tr>
                <tr
                  v-if="!item.inMatrix"
                  class="delete-row"
                >
                  <td>
                    {{ generateRowName(item.options) }}
                  </td>
                  <td>
                    <span class="red--text">This variant no longer exists and will be deleted</span>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </template>

            </tbody>

          </template>
        </v-data-table>
      </v-col>
    </v-row>

  </div>
</template>
<style>
  tr.delete-row td {
    border-top: thin solid red;
    border-bottom: thin solid red;
  }

  tr.delete-row td:first-child {
    border-left: thin solid red;
  }

  tr.delete-row td:last-child {
    border-right: thin solid red;
  }

  tr.new-row {
    background: #2c3f2b;
    color: white !important;
  }

  tr.new-row td {
    border-top: solid #006f11;
    border-bottom: solid #006f11;
  }

  tr.new-row td:first-child {
    border-left: solid #006f11;
  }

  tr.new-row td:last-child {
    border-right: solid #006f11;
  }
</style>
<script>
import AmountInput from "../Common/AmountInput"
import { isEmpty, isString, cloneDeep, get, isNumber } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { dayOfWeekParsed, weekOfYearParsed, dateRangeParsed } from "../../services/util.service"

export default {
  components: {
    AmountInput
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    options: {
      handler() {
        if (this.doesTemplateIncludeWeekOfYear()) {
          const values = this.getOptionValuesForWeekOfYear()
          this.numPages = values.length
          if (!this.page) this.page = 1
        }
        this.variants = { ...this.variants }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([ 'getVariantsByProduct' ]),
    items() {
      let rows = this.generateRows()

      if (this.product.id) {
        // edit
        this.setVariantsAndRowsToModel(rows)
      } else {
        // create
        this.setRowsToModel(rows)
      }
      // Maybe only sort in edit state?
      // return rows.sort((a, b) => {
      //   return !!a.isExcluded - !!b.isExcluded
      // })

      // this should always be returning the model. if things were updated properly, no?
      // Temporary...Variants are modified when the items update, so we emit the change, hopefully not causing too many emits
      this.$emit('change-variants', { ...this.variants })

      // console.log('-END', Object.values(this.variants).length)
      // console.log('-END', Object.values(this.variants)[ 0 ])

      const optIndex = this.getOptionIndexForWeekOfYear()
      const weeks = this.getOptionValuesForWeekOfYear()

      const filteredItems = Object.values(this.variants)
        .filter(v => {
          if (this.doesTemplateIncludeWeekOfYear()) {
            const weekValue = weeks[ this.page - 1]
            return v.options[optIndex].value === weekValue
          } else {
            return true
          }
        })

      return filteredItems
    }
  },
  mounted() {
    if (this.product.id) {
      this.variants = this.product.variants.reduce((acc, curr) => ({
        ...acc,
        [ curr.id ]: curr
      }), {})
    }
  },
  methods: {
    ...mapActions([ 'initVariantsForProduct' ]),
    doesTemplateIncludeWeekOfYear() {
      // quick and dirty for now
      return get(this.template, 'meta.options[1].type') === 'weekOfYear'
        || get(this.template, 'meta.options[2].type') === 'weekOfYear'
        || get(this.template, 'meta.options[3].type') === 'weekOfYear'
    },
    getOptionValuesForWeekOfYear() {
      // quick and dirty for now
      if( get(this.template, 'meta.options[1].type') === 'weekOfYear') {
        return get(this.options, '[1].values', [])
      } else if (get(this.template, 'meta.options[2].type') === 'weekOfYear') {
        return get(this.options, '[2].values', [])
      } else if (get(this.template, 'meta.options[3].type') === 'weekOfYear') {
        return get(this.options, '[3].values', [])
      } else {
        return []
      }
    },
    getOptionIndexForWeekOfYear() {
      // quick and dirty for now
      if( get(this.template, 'meta.options[1].type') === 'weekOfYear') {
        return 1
      } else if (get(this.template, 'meta.options[2].type') === 'weekOfYear') {
        return 2
      } else if (get(this.template, 'meta.options[3].type') === 'weekOfYear') {
        return 3
      } else {
        return null
      }
    },
    doFillColumns(items) {
      items.forEach(item => {

        // lazy way for now
        if (this.fillColumns.amount > 0) {
          this.updateModel(item, 'amount', this.fillColumns.amount)
        }
        if (this.fillColumns.quantity !== null) {
          this.updateModel(item, 'quantity', this.fillColumns.quantity)
        }
        if (this.fillColumns.sku !== null) {
          this.updateModel(item, 'sku', this.fillColumns.sku)
        }
        if (this.fillColumns.weight !== null) {
          this.updateModel(item, 'weight', this.fillColumns.weight)
        }
        if (this.fillColumns.weightUnits !== null) {
          this.updateModel(item, 'weightUnits', this.fillColumns.weightUnits)
        }
      })

      // Commenting out for now since current main UC is quick data entry
      // this.fillColumns = {
      //   amount: 0, // ignore 0?
      //   quantity: null,
      //   sku: null,
      //   weight: null,
      //   weightUnits: null
      // }
    },
    _isNumber: (val) => isNumber(val),
    generateRows() {
      const options = Object.values(this.options)
        .filter(o => Array.isArray(o.values) && o.values.length > 0)
        .map(o => o.values)

      let output = []
      if (!isEmpty(options)) {
        output = options.reduce((acc, curr, i) =>
          acc.flatMap(c => curr.map(n => [].concat(c, n)))
        )
      }

      // The above function is nice, but the drawback is that when there is only 1 option with values
      // it just returns the array of values, so we must format this condition like the other cases
      if (isString(output[ 0 ]) || isNumber(output[ 0 ])) {
        output = output.map(o => [ o ])
      }

      const rows = output.map(o => {
        const optionMap = o.reduce((acc, curr) => {
          for (const [ key, option ] of Object.entries(this.options)) {
            const values = option.values && Array.isArray(option.values) ? option.values : []
            if (values.includes(curr)) {
              acc[ key ] = {
                value: curr
              }
            }
          }
          return acc
        }, {})

        return {
          rowId: this.generateTmpRowId(o),
          name: this.generateRowName(optionMap),
          options: { ...optionMap },
          isExcluded: false,
          amount: 0,
          quantity: 0,
          sku: '',
          weight: 0,
          weightUnits: ''
        }
      })

      return rows
    },
    setVariantsAndRowsToModel(rows) {
      /**
       * Can only be used in the UPDATE scenario
       * */
      let unusedVariantsMap = {}
      let rowMap = rows.reduce((acc, curr) => ({ ...acc, [ curr.rowId ]: curr }), {})
      // Apply existing first
      const currentVariants = Object.values({ ...this.variants }) // inits with ones in DB for product

      unusedVariantsMap = currentVariants.reduce((acc, curr) => {
        // some current variants may not have an ID, but their row ID is the ID
        const indexId = curr.id || curr.rowId

        return { ...acc, [ indexId ]: curr }
      }, {})

      const variants = Object.values(unusedVariantsMap)

      const updatedRows = rows.map(row => {
        const existingVariant = variants.find(v => {
          return get(v, 'options[1].value') === get(row, 'options[1].value')
            && get(v, 'options[2].value') === get(row, 'options[2].value')
            && get(v, 'options[3].value') === get(row, 'options[3].value')
        })

        // existing variant could be an old one (id) or new one (rowId)
        if (existingVariant) {
          const indexId = existingVariant.id || existingVariant.rowId
          delete unusedVariantsMap[ indexId ]

          existingVariant.inMatrix = true
        } else {
          row.inMatrix = true
        }

        return existingVariant
          ? { ...row, ...existingVariant }
          : { ...row }
      })

      const unusedVariants = []
      for (const [ variantId, variant ] of Object.entries(unusedVariantsMap)) {
        if (variantId in rowMap) {
          variant.inMatrix = true
        } else {
          variant.inMatrix = false
        }

        unusedVariants.push(variant)
      }

      const totalRows = [ ...updatedRows, ...unusedVariants ]

      this.variants = totalRows.reduce((acc, curr) => {
        // If the ID exists, thats the ultimate row Id
        const id = curr.id || curr.rowId
        curr.name = this.generateRowName(curr.options)

        return {
          ...acc,
          [ id ]: curr
        }
      }, {})

      return totalRows
    },
    setRowsToModel(rows) {
      /**
       * WORKING FOR CREEATE
       */
        // Only use the values if they are not empty/zero
      const newVariants = {}
      for (const row of rows) {
        const { rowId } = row

        const currVariant = this.variants[ rowId ] || {}

        newVariants[ rowId ] = {
          ...row,
          inMatrix: true,
          isExcluded: get(currVariant, `isExcluded`) === true || get(currVariant, `isExcluded`) === false
            ? currVariant.isExcluded
            : row.isExcluded,
          weight: get(currVariant, `weight`)
            ? currVariant.weight
            : row.weight,
          weightUnits: get(currVariant, `weightUnits`)
            ? currVariant.weightUnits
            : row.weightUnits,
          sku: get(currVariant, `sku`) ? currVariant.sku : row.sku,
          amount: parseInt(get(currVariant, `amount`, 0), 10) > 0
            ? parseInt(currVariant.amount, 10)
            : parseInt(row.amount, 10),
          quantity: parseInt(get(currVariant, `quantity`, 0), 10) > 0
            ? currVariant.quantity
            : row.quantity,
        }
      }

      // Create must always return exactly the variants
      this.variants = newVariants
    },
    generateRowName(optionMap) {
      const templateTypeMap = {
        dayOfWeek: (day) => dayOfWeekParsed(day),
        weekOfYear: (week) => weekOfYearParsed(week),
        dateRange: (range) => dateRangeParsed(range)
      }

      const name = []
      if (optionMap) {
        for (const [ optionNum, data ] of Object.entries(optionMap)) {
          const optionTemplateType = get(this.template, `meta.options[${optionNum}].type`)

          if (optionTemplateType in templateTypeMap) {
            name.push(get(templateTypeMap[ optionTemplateType ](data.value), 'label'))
          } else {
            name.push(data.value)
          }
        }
      }

      return name.join(' / ')
    },
    generateTmpRowId(variants) {
      // @todo use a better unique id method, this should be temporary
      return variants.join('----')
    },
    updateModel(variant, attribute, value) {
      const variantId = variant.id || variant.rowId
      // We update objects this way so the UI is reactive
      const variants = cloneDeep(this.variants)

      //console.log('updating', variantId, attribute, value)

      this.variants = {
        ...variants,
        [ variantId ]: {
          ...variants[ variantId ],
          [ attribute ]: value
        }
      }
      // updated in items compute function?
      //this.$emit('change-variants', { ...this.variants })
    },
    fillchange(val) {
      this.fillColumns.amount = val
    }
  },
  data() {
    return {
      filters: {},
      fillColumns: {
        // use null to represent "ignore" column fill
        amount: 0, // ignore 0?
        quantity: null,
        sku: null,
        weight: null,
        weightUnits: null
      },
      page: null,
      numPages: 0,
      loadedVariants: false,
      variants: {},
      isExcludedMap: {},
      weightUnits: [
        {
          id: 'kg',
          label: 'kg'
        },
        {
          id: 'g',
          label: 'g'
        },
        {
          id: 'lb',
          label: 'lb'
        },
        {
          id: 'oz',
          label: 'oz'
        },
      ],
      headers: [
        {
          text: 'Variant',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Price',
          align: 'left',
          sortable: false,
          value: 'amount',
        },
        {
          text: 'Quantity',
          align: 'left',
          sortable: false,
          value: 'quantity',
        },
        {
          text: 'SKU',
          align: 'left',
          sortable: false,
          value: 'sku',
        },
        {
          text: 'Weight',
          align: 'left',
          sortable: false,
          value: 'quantity',
        },
        {
          text: 'Actions',
          align: 'right',
          sortable: false,
        }
      ],
    }
  },
}
</script>
